import { LoaderElement } from '@/components/features/shared/LoaderElement'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { UserRole } from '@/domain/auth/auth'
import { useAccounts } from '@/hooks/api/useAccounts'
import { Paths } from '@/routes/paths'
import { useAuthStore } from '@/store/useAuthStore'
import { useNavigate } from '@tanstack/react-router'
import { ArrowRight, Scale, Users, Wallet } from 'lucide-react'

export const AccountsMenu = () => {
  const navigate = useNavigate()
  const hasSuperAdmin = useAuthStore((state) => state.hasAnyRole([UserRole.SuperAdmin, UserRole.Scheduler]) )
  const { data: mainAccounts, isLoading: isLoadingMain } = useAccounts({
    isMain: true,
    limit: 1000
  })
  const isLoading = isLoadingMain 

  if (isLoading) {
    return <LoaderElement />
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Caja</h1>
          <p className="text-muted-foreground">
            Selecciona una opción para gestionar
          </p>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <div className="p-1 bg-blue-500/10 rounded-md">
                <Wallet className="h-4 w-4 text-blue-500" />
              </div>
              <CardTitle className="text-lg">Cuentas de Clientes</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <Button
              size="lg"
              onClick={() => navigate({ to: `${Paths.Management.Accounts}` })}
              className="w-full max-w-lg"
              variant="outline">
              Ver Cuentas de Clientes
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <div className="p-1 bg-primary/10 rounded-md">
                <Wallet className="h-4 w-4 text-primary" />
              </div>
              <CardTitle className="text-lg">Cuentas Principales</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <Button
              size="lg"
              onClick={() => navigate({ to: `${Paths.Management.MainAccounts}` })}
              className="w-full max-w-lg"
              disabled={!hasSuperAdmin}
              variant="outline">
              Ver Cuentas Principales
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <div className="p-1 bg-green-500/10 rounded-md">
                <Users className="h-4 w-4 text-green-500" />
              </div>
              <CardTitle className="text-lg">Cuentas Cobradores</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <Button
              size="lg"
              onClick={() => navigate({ to: `${Paths.Management.CollectorAccounts}` })}
              className="w-full max-w-lg"
              disabled={!hasSuperAdmin}
              variant="outline">
              Ver Cuenta Cobradores
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <div className="p-1 bg-amber-500/10 rounded-md">
                <Scale className="h-4 w-4 text-amber-500" />
              </div>
              <CardTitle className="text-lg">Balance de Caja</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <Button
              size="lg"
              onClick={() => navigate({ to: `${Paths.Management.CashBox}/${mainAccounts?.data?.[0]?.userId}` })}
              className="w-full max-w-lg"
              variant="outline">
              Ver Balance de Caja
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </CardContent>
        </Card>

      </div>
    </div >
  )
}
